import React from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

const ModalFooter = ({ children, className }) => {
  return (
    <div
      className={clsx([
        'modal__container__footer flex flex-jc-sb flex-ai-c',
        className,
      ])}
    >
      {children}
    </div>
  );
};

ModalFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ModalFooter;
